module.exports = __webpack_public_path__ + "static/media/TM-30-Web-Library-Excel-Input.f86d8454.xlsx";